/* eslint-disable @typescript-eslint/camelcase */
import { BusinessActionType, BusinessAction } from '../actions/businessActions';

export type BusinessStatus = {
  OK: 'OK';
  FETCHING: 'FETCHING';
  FETCHING_NAME: 'FETCHING_NAME';
  FETCH_ERROR: 'FETCH_ERROR';
};

export interface BusinessState {
  name: string | null;
  status: keyof BusinessStatus;
}

const initialState: BusinessState = {
  name: null,
  status: 'OK'
};

function businessReducers(state = initialState, action: BusinessAction): BusinessState {
  switch (action.type) {
    case BusinessActionType.Fetch:
      return {
        ...state,
        status: 'FETCHING'
      };
    case BusinessActionType.FetchSuccess:
      return {
        ...state,
        name: action.payload.legal_name,
        status: 'OK'
      };
    case BusinessActionType.FetchError:
      return {
        ...state,
        status: 'FETCH_ERROR'
      };
    case BusinessActionType.PutName:
      return {
        ...state,
        name: action.payload,
        status: 'FETCHING_NAME'
      };
    case BusinessActionType.PutNameSuccess:
      return {
        ...state,
        name: action.payload.legal_name,
        status: 'OK'
      };
    default:
      return state;
  }
}

export default businessReducers;
